import wcShared from '@web-components/shared';

import { ProductName, ProductNames } from './productName';

export interface Product {
  name: ProductName;
  displayName: string;
  icon: string;
  url: (orgId?: number) => string;
  defaultPath?: string;
  isDisabled?: boolean;
}

export const ProductsRouting = wcShared.store.productsRouting;
export const ksuiteUrl = ProductsRouting.ksuite;
export const FreeProducts = {
  [ProductNames.KMEET]: {
    name: ProductNames.KMEET,
    displayName: 'kMeet',
    icon: 'app-kmeet',
    url: () => ProductsRouting.meet,
  },
  [ProductNames.SWISSTRANSFER]: {
    name: ProductNames.SWISSTRANSFER,
    displayName: 'SwissTransfer',
    icon: 'app-swisstransfer',
    url: () => ProductsRouting.swisstransfer,
  },
  [ProductNames.KPASTE]: {
    name: ProductNames.KPASTE,
    displayName: 'kPaste',
    icon: 'app-kpaste',
    url: () => ProductsRouting.kpaste,
  },
  [ProductNames.CHK]: {
    name: ProductNames.CHK,
    displayName: 'Chk',
    icon: 'app-chk',
    url: () => ProductsRouting.chk,
  },
} as Record<ProductName, Product>;
export const Products: Record<ProductName, Product> = {
  [ProductNames.KSUITE]: {
    name: ProductNames.KSUITE,
    get displayName() {
      return wcShared.translate('Ma journée');
    },
    icon: 'home-ksuite',
    url: (orgId?: number) => `${ksuiteUrl}${orgId ? `/${orgId}` : ''}`,
  },
  [ProductNames.KCHAT]: {
    name: ProductNames.KCHAT,
    displayName: 'kChat',
    icon: 'app-kchat',
    url: (orgId?: number) => `${ksuiteUrl}${orgId ? `/${orgId}` : ''}/kchat`,
  },
  [ProductNames.MAIL]: {
    name: ProductNames.MAIL,
    displayName: 'Mail',
    icon: 'app-mail',
    url: (orgId?: number) => `${ksuiteUrl}${orgId ? `/${orgId}` : ''}/mail`,
  },
  [ProductNames.CALENDAR]: {
    name: ProductNames.CALENDAR,
    displayName: 'Calendar',
    icon: 'app-calendar',
    url: (orgId?: number) => `${ksuiteUrl}${orgId ? `/${orgId}` : ''}/calendar`,
  },
  [ProductNames.KDRIVE]: {
    name: ProductNames.KDRIVE,
    displayName: 'kDrive',
    icon: 'app-kdrive',
    url: (orgId?: number) => `${ksuiteUrl}${orgId ? `/${orgId}` : ''}/kdrive`,
  },
  [ProductNames.EURIA]: {
    name: ProductNames.EURIA,
    displayName: 'Euria',
    icon: 'app-euria',
    url: (orgId?: number) => `${ksuiteUrl}${orgId ? `/${orgId}` : ''}/euria`,
  },
  [ProductNames.CONTACTS]: {
    name: ProductNames.CONTACTS,
    displayName: 'Contacts',
    icon: 'app-contacts',
    url: (orgId?: number) => `${ksuiteUrl}${orgId ? `/${orgId}` : ''}/contacts`,
  },
  [ProductNames.SMS]: {
    name: ProductNames.SMS,
    displayName: 'Sms',
    icon: 'app-sms',
    url: () => ProductsRouting.sms,
  },
  ...FreeProducts,
};

export type Products = typeof Products;

export const PRODUCT_WITH_ACCESS_MAPPING = {
  drives: ProductNames.KDRIVE,
  mails: ProductNames.MAIL,
  kchats: ProductNames.KCHAT,
  has_euria: ProductNames.EURIA,
};
